import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class RiskInputService {
  static getSupplier(cId, key) {
    return HttpUtil.get(
      API_ROUTES.RISKINPUT.SUPPLIERLIST.replace("<companyId>", cId) +
        `?key=${key}`
    );
  }

  static getSupplierData(
    encodedUrlParam,
    supplierId,
    period,
    paramId,
    configType = ""
  ) {
    var url = API_ROUTES.RISKINPUT.SUPPLIERDATA.replace(
      "<encodedUrlParam>",
      encodedUrlParam
    )
      .replace("<supplierId>", supplierId)
      .replace("<period>", period)
      .replace(configType ? "<type>" : "?type=<type>", configType);
    if (paramId != null) {
      url += `&paramId=${paramId}`;
    }
    return HttpUtil.get(url);
  }

  static saveDataPoint(encodedUrlParam, supplierId, period, body) {
    return HttpUtil.post(
      API_ROUTES.RISKINPUT.SAVEDATAPOINT.replace(
        "<encodedUrlParam>",
        encodedUrlParam
      )
        .replace("<supplierId>", supplierId)
        .replace("<period>", period),
      body
    );
  }
  static getCompanyData(companyId, regulationId, period, configType = "", paramId) {
    var url = API_ROUTES.RISKINPUT.COMPANYDATA.replace("<companyId>", companyId)
      .replace("<regulationId>", regulationId)
      .replace("<period>", period)
      .replace(configType ? "<type>" : "?type=<type>", configType);
      if (paramId != null) {
        url += `&paramId=${paramId}`;
      }
    return HttpUtil.get(url);
  }
  static saveCompanyDataPoint(companyId, regulationId, period, payload) {
    return HttpUtil.post(
      API_ROUTES.RISKINPUT.SAVECOMPANYDATAPOINT.replace(
        "<companyId>",
        companyId
      )
        .replace("<regulationId>", regulationId)
        .replace("<period>", period),
      payload
    );
  }
}
